import {get, type Writable, writable} from 'svelte/store';
import SingletonDependency from 'Lib/SingletonDependency';
import {Scenario, ScenarioPublicData} from 'Generated/RestClient.g';
import type {Nullable} from 'Lib/Utils/Nullable';

export default class PresentationContext extends SingletonDependency {
    public currentScenarioObservable: Writable<Nullable<Scenario>> = writable(undefined);
    public currentScenarioPublicDataObservable: Writable<Nullable<ScenarioPublicData>> = writable(undefined);
    public presentationOwnedByCurrentUserObservable: Writable<boolean> = writable(false);
    public presentationLoadedObservable: Writable<boolean> = writable(false);
    public instanceErrorObservable: Writable<Nullable<string>> = writable(undefined);
    public isOccupiedObservable: Writable<boolean> = writable(false);
    public passwordNeededObservable: Writable<boolean> = writable(false);
    public passwordErrorObservable: Writable<Nullable<string>> = writable(undefined);
    public showLoadingIndicatorObservable: Writable<boolean> = writable(false);
    public showPresentationLogsObservable: Writable<boolean> = writable(false);
    public isEmbeddedObservable: Writable<boolean> = writable(false);
    public globalTextOverlayObservable: Writable<string | undefined> = writable(undefined);
    public containerLogsObservable: Writable<Nullable<string>> = writable(undefined);
    public shutdownInitiatedObservable: Writable<boolean> = writable(false);

    public get currentScenario(): Nullable<Scenario> {
        return get(this.currentScenarioObservable);
    }

    public set currentScenario(scenario: Nullable<Scenario>) {
        this.currentScenarioObservable.set(scenario);
    }

    public get currentScenarioPublicData(): Nullable<ScenarioPublicData> {
        return get(this.currentScenarioPublicDataObservable);
    }

    public set currentScenarioPublicData(scenario: Nullable<ScenarioPublicData>) {
        this.currentScenarioPublicDataObservable.set(scenario);
    }

    public get showPresentationLogs(): boolean {
        return get(this.showPresentationLogsObservable);
    }

    public set showPresentationLogs(showPresentationLogs: boolean) {
        this.showPresentationLogsObservable.set(showPresentationLogs);
    }

    public get presentationOwnedByCurrentUser(): boolean {
        return get(this.presentationOwnedByCurrentUserObservable);
    }

    public set presentationOwnedByCurrentUser(presentationWritable: boolean) {
        this.presentationOwnedByCurrentUserObservable.set(presentationWritable);
    }

    public get presentationLoaded(): boolean {
        return get(this.presentationLoadedObservable);
    }

    public set presentationLoaded(presentationLoaded: boolean) {
        this.presentationLoadedObservable.set(presentationLoaded);
    }

    public get instanceError(): Nullable<string> {
        return get(this.instanceErrorObservable);
    }

    public set instanceError(error: Nullable<string>) {
        this.instanceErrorObservable.set(error);
    }

    public set passwordNeeded(val: boolean) {
        this.passwordNeededObservable.set(val);
    }

    public get passwordNeeded() {
        return get(this.passwordNeededObservable);
    }

    public set passwordError(val: Nullable<string>) {
        this.passwordErrorObservable.set(val);
    }

    public get showLoadingIndicator() {
        return get(this.showLoadingIndicatorObservable);
    }

    public set showLoadingIndicator(val) {
        this.showLoadingIndicatorObservable.set(val);
    }

    public get isEmbedded() {
        return get(this.isEmbeddedObservable);
    }

    public set isEmbedded(val: boolean) {
        this.isEmbeddedObservable.set(val);
    }

    public get isOccupied() {
        return get(this.isOccupiedObservable);
    }

    public set isOccupied(val: boolean) {
        this.isOccupiedObservable.set(val);
    }

    public get getGlobalTextOverlay() {
        return get(this.globalTextOverlayObservable);
    }

    public set setGlobalTextOverlay(val: string | undefined) {
        this.globalTextOverlayObservable.set(val);
    }

    public get containerLogs(): Nullable<string> {
        return get(this.containerLogsObservable);
    }

    public set containerLogs(containerLogs: Nullable<string>) {
        this.containerLogsObservable.set(containerLogs);
    }

    public get shutdownInitiated(): boolean {
        return get(this.shutdownInitiatedObservable);
    }

    public set shutdownInitiated(value: boolean) {
        this.shutdownInitiatedObservable.set(value);
    }
}
